import React, { memo, useContext, useState } from "react";
import { makeStyles, Tooltip } from "@material-ui/core";
import { Build, Edit } from "@material-ui/icons";
import moment from "moment";
import { useQueryClient } from "react-query";
import { ComboSelect } from "..";
import AircraftDefectsDialog from "../../modules/Aircraft/components/AircraftDefectsDialog";
import useAircraftDispatchDeviations from "../../services/aircraft/useAircraftDispatchDeviations";
import SystemContext from "../../SystemContext";
import ContextMenu from "../ContextMenu";

const Styles = (theme) => {
  return {
    Tooltip: {
      width: 700,
      minWidth: 700
    },
    DeviationContent: {
      padding: 10
    },
    DeviationHeader: {
      paddingTop: 10,
      paddingLeft: 10
    },
    DeviationHeaderText: {
      display: "inline-block",
      textAlign: "left",
      fontSize: 18,
      fontWeight: "bold",
      paddingLeft: 5
    },
    DeviationTableHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontWeight: "bold",
    },
    DeviationRow: {

    },
    DeviationCategory: {
      display: "inline-block",
      width: 160,
      padding: 3
    },
    DeviationReportedOn: {
      display: "inline-block",
      width: 80,
      padding: 3
    },
    DeviationReportedAt: {
      display: "inline-block",
      width: 60,
      padding: 3
    },
    DeviationAirport: {
      display: "inline-block",
      width: 60,
      padding: 3
    },
    DeviationDetails: {
      display: "inline-block",
      width: 240,
      padding: 3
    },
    AircraftWrapper: {
      padding: 3,
    },
    AircraftWrapperExternal: {
      padding: 3,
    },
    AircraftText: {
      paddingTop: 2,
      paddingBottom: 2
    },

    DefectsEditor: {
      "& .MuiTableHead-root": {
        backgroundColor: theme.palette.childTableHeader.backgroundColor,
        display: "block",
        tableLayout: "fixed",
        paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
        color: theme.palette.secondary.main,
      }
    },
  }
};

const DeviationList = (props) => {
  const {deviations, classes} = props;

  return (<div className={classes.Tooltip}>
    <div className={classes.DeviationHeader}>
      <div style={{display: "inline-block"}}><Build style={{position: "relative", top: 2, fontSize:16}}/></div>
      <div className={classes.DeviationHeaderText}>Deferred Defects</div>
    </div>
    <div className={classes.DeviationContent}>
    <div className={classes.DeviationTableHeader}>
      <div className={classes.DeviationCategory}>Category</div>
      <div className={classes.DeviationReportedOn}>Reported On</div>
      <div className={classes.DeviationReportedAt}>At</div>
      <div className={classes.DeviationAirport}>At Airport</div>
      <div className={classes.DeviationDetails}>Defect Details</div>
    </div>
    {deviations.map(deviation => (
      <div className={classes.DeviationRow}>
        <div className={classes.DeviationCategory}>
          <ComboSelect
            group="DISPATCH DEVIATIONS"
            subGroup=""
            value={deviation.deviationCategory}
            displayOnly={true}
          />
        </div>
        <div className={classes.DeviationReportedOn}>{moment.utc(deviation.reportedOn).format("D MMM YYYY")}</div>
        <div className={classes.DeviationReportedAt}>{moment.utc(`9999-12-31 ${deviation.reportedTime||'00:00'}`, 'YYYY-MM-DD HH:mm').format("HH:mm")}</div>
        <div className={classes.DeviationAirport}>{deviation.atAirport}</div>
        <div className={classes.DeviationDetails}>{deviation.details}</div>
      </div>
    ))}
    </div>
  </div>)
}

const AircraftRegWithDefects = (props) => {
  const queryClient = useQueryClient();
  const classes = makeStyles(Styles)();
  const SystemData = useContext(SystemContext);

  const [deferredDefects, setDeferredDefects] = useState({
    showDeferredDefects: false
  });

  const {aircraftReg } = props;
  const deviations = useAircraftDispatchDeviations({queryClient, extraKeys: [aircraftReg, 'LATEST']});

  const handleEditDeferredDefects = (action) => {
    setDeferredDefects({showDeferredDefects: true});
  }

  const aircraftTailNumber = aircraftReg.split('|').length > 1 ? aircraftReg.split('|')[1] : aircraftReg;
  const externalAircraft = aircraftReg.split('|').length > 1;

  if (externalAircraft) {
    return (
      <div className={classes.AircraftWrapperExternal}>
        <div className={classes.AircraftText}>{aircraftTailNumber}</div>
      </div>
    )
  }

  const dialog = deferredDefects.showDeferredDefects
    ? <AircraftDefectsDialog
      open={deferredDefects.showDeferredDefects}
      record={{aircraftTailNumber: aircraftReg}}
      title={"Deferred Defects for " + aircraftReg}
      aircraftTailNumber={aircraftReg}
      SystemData={SystemData}
      classes={classes}
      onChange={() => {
        setDeferredDefects({showDeferredDefects: false});
      }}
    />
    : null;

    if (!props.canViewDetails) {
    return (
      <div className={classes.AircraftWrapper}>
        <div className={classes.AircraftText}>{aircraftReg}</div>
      </div>
    )
  }
  
  if (deviations && Array.isArray(deviations.data) && deviations.data.length > 0){
    return (
      <>
        <ContextMenu
          menuItems={props.canChange?[{code: "EDIT", label: "Edit", icon: (<Edit/>), action: handleEditDeferredDefects}]:[]}
        >
          <Tooltip
            classes={{ tooltip: classes.Tooltip }}
            placement="right"
            arrow
            interactive
            leaveDelay={300}
            title={(<DeviationList deviations={deviations.data} classes={classes}/>)}
          >
            <div className={classes.AircraftWrapper}>
              <div className={classes.AircraftText} style={{backgroundColor: "#ffff00", color: "#000000", border: "1px solid grey"}}>{aircraftReg}</div>
            </div>
          </Tooltip>
        </ContextMenu>
        {dialog}
      </>
    )
  }
  return (
    <>
      <ContextMenu
        menuItems={props.canChange?[{code: "EDIT", label: "Edit", icon: (<Edit/>), action: handleEditDeferredDefects}]:[]}
      >
        <div className={classes.AircraftWrapper}>
          <div className={classes.AircraftText}>{aircraftReg}</div>
        </div>
      </ContextMenu>
      {dialog}
    </>
  )
}

export default memo(AircraftRegWithDefects);
